import React, {useState} from "react";

import {useAuth} from "oidc-react";
import {useDispatch, useSelector} from "react-redux";
import BackDrop from "../components/utils/back-drop";
import * as STATUS from "../httpClient";
import {UserManagementHeader} from "../components/user-management/user-management-header";
import {Container, createTheme, CssBaseline} from "@mui/material";
import {ThemeProvider} from "@mui/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {Search} from "@mui/icons-material";
import ResponsiveStack from "../components/utils/responsive-stack";
import Stack from "@mui/material/Stack";
import {UserSearchFields} from "../components/user-management/user-search-field-selector";
import {searchUsersByFilter} from "../features/user-management/user-managementAPI";
import Button from "@mui/material/Button";
import CenterDiv from "../components/utils/center-div";
import {FAILED, LOADING, SUCCESS} from "../httpClient";
import {UserBasicCard} from "../components/user-management/user-basic-card";
import {ListStudyNotes} from "../components/study-note/list-study-notes";
import PageWrapper from "../components/utils/PageWrapper";
import {ListUsers} from "../components/user-management/list-users";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import {Alert} from "@mui/lab";

const theme = createTheme({
    typography: {
        fontFamily: [
            'Open Sans Condensed',
            'sans-serif'
        ].join(','),
    },
});

const UserManagementPage = () => {
    const auth = useAuth();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch();

    const searchFields = [
        "email",
        "given_name",
        "family_name"
    ];

    const [searchField, setSearchField] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [searchValueError, setSearchValueError] = useState(false);
    const [searchFieldError, setSearchFieldError] = useState(false);
    const [status, setStatus] = useState('idle');
    const [users, setUsers] = useState([]);

    const handleSearchFieldValueChange = e => {
        if (searchFieldError) {
            setSearchFieldError(false);
        }
        setSearchField(e)
    }

    const handleSearchValueChange = e => {
        if (searchValueError) {
            setSearchValueError(false);
        }
        setSearchValue(e.target.value)
    }

    const search = () => {
        setSearchValueError(false);
        setSearchFieldError(false);

        if (searchValue.length < 3) {
            setSearchValueError(true);
        }

        if (searchField === '') {
            setSearchFieldError(true);
        }


        if (searchFieldError || searchValueError) {
            return;
        }

        setStatus(LOADING);

        const body = {
            fieldName: searchField,
            fieldValue: searchValue
        }

        searchUsersByFilter(auth.userData.access_token, JSON.stringify(body))
            .then(data => {
                setUsers(data);
                setStatus(SUCCESS);
            })
            .catch(err => {
                setStatus(FAILED);
                console.log(err);
            })
    }



    const mobileForm =  <div style={{ textAlign: 'center'}}>
        <CssBaseline />
        <Container maxWidth="sm" sx={{ mt: '3rem'}}>
            <Stack spacing={3}>
                <Stack spacing={3}>
                    <UserSearchFields
                        searchFields={searchFields}
                        selectSearchField={setSearchField}
                        error={searchFieldError}
                    />

                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                        <TextField
                            value={searchValue}
                            id="input-with-sx"
                            label="Search value"
                            variant="standard"
                            error={searchValueError}
                            fullWidth
                            onChange={e => setSearchValue(e.target.value)}
                        />
                    </Box>

                    <CenterDiv>
                        <Button size={"large"} variant={"contained"} color={"primary"} onClick={() => search()}>
                            <Search/> search
                        </Button>
                    </CenterDiv>
                </Stack>
            </Stack>
        </Container>
    </div>;
    const webForm =  <CenterDiv>
        <div style={{width: "70%", display: "flex", flexDirection: "row"}}>
            <div style={{width: '50%', paddingRight: '1rem'}}>
                <UserSearchFields
                    searchFields={searchFields}
                    selectSearchField={handleSearchFieldValueChange}
                    error={searchFieldError}
                />
            </div>

            <div style={{width: '50%', paddingRight: '1rem'}}>
                <TextField
                    value={searchValue}
                    id="input-with-sx"
                    label="Search value"
                    variant="standard"
                    error={searchValueError}
                    fullWidth
                    onChange={handleSearchValueChange}
                />
            </div>

            <CenterDiv>
                <Button variant={"text"} color={"primary"} onClick={() => search()}>
                    <Search/> search
                </Button>
            </CenterDiv>
        </div>
    </CenterDiv>

    return (
        <div>
            <UserManagementHeader/>

            <ThemeProvider theme={theme}>
                {
                    matches ?
                        <PageWrapper>
                            <Paper elevation={0}>
                                {webForm}
                            </Paper>
                        </PageWrapper> :
                        mobileForm
                }

                {
                    status === SUCCESS && users.length > 0 ?
                        <PageWrapper mt={'3rem'}>
                            <ListUsers users={users} reload={search}/>
                        </PageWrapper>
                        :
                        status === SUCCESS || status === FAILED ?
                            <>
                                <div style={{ margin: '1rem'}}/>
                                <CenterDiv>
                                    <Alert severity={"error"} sx={{ width: matches ? '40%' : 'none'}}>
                                        No users found
                                    </Alert>
                                </CenterDiv>
                            </>
                            :
                            null
                }
            </ThemeProvider>
            <BackDrop open={status === STATUS.LOADING} message={"one moment please"}/>
        </div>
    )
}
export default UserManagementPage;
